// extracted by mini-css-extract-plugin
export default {"localFooter":"LocalFooter_localFooter__VgZmw"};